import React, { useState } from 'react';
import { CONSTANTS } from '../utils/constants';
import { CountdownTimer } from './CountdownTimer';
import { PaymentBadges } from './PaymentBadges';
import { Check, ShieldCheck, ArrowRight, Download, Mail, Star, Crown, Sparkles, BookOpen } from 'lucide-react';
export const OfferSection: React.FC = () => {
  const [selectedPlan, setSelectedPlan] = useState<'standard' | 'premium'>('premium');
  const handleBuyStandard = () => {
    window.open(CONSTANTS.PAYMENT_LINK, '_blank');
  };
  const handleBuyPremium = () => {
    window.open(CONSTANTS.PREMIUM_PAYMENT_LINK, '_blank');
  };
  const standardItems = [{
    label: 'Ebook Principal Gimnasia Artística',
    free: false
  }, {
    label: 'Plantilla Plan Anual Editable',
    free: true
  }, {
    label: 'Checklist de Seguridad',
    free: true
  }, {
    label: 'Guía Comunicación Padres',
    free: true
  }, {
    label: 'Selección Ejercicios Favoritos',
    free: true
  }, {
    label: 'Plantilla Evaluación Gimnasta',
    free: true
  }];
  const premiumExtras = [{
    label: '180 Ejercicios de Gimnasia Artística por Edad',
    desc: 'Guía práctica para profesores: progresiones seguras de 3 a 16 años'
  }, {
    label: 'Mentalidad, Técnica y Progresión',
    desc: 'Lecciones del caso Simone Biles para entrenadores de gimnasia artística'
  }, {
    label: 'Plan de Entrenamiento Completo GAM (Masculino)',
    desc: 'Sistema de entrenamiento completo para gimnasia artística masculina'
  }];
  return <section id="oferta" className="py-20 bg-gray-50 scroll-mt-20" data-id="element-157">
      <div className="max-w-6xl mx-auto px-4" data-id="element-158">
        <div className="text-center mb-12" data-id="element-159">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-160">
            Elegí Tu Pack Ideal
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-161">
            Descarga inmediata. Pago 100% seguro. Garantía de 45 días.
          </p>
        </div>

        {/* Countdown */}
        <div className="flex justify-center mb-12" data-id="element-162">
          <div className="inline-flex items-center justify-center space-x-2 bg-red-50 text-red-600 px-6 py-3 rounded-full border border-red-100" data-id="element-163">
            <span className="font-bold text-sm uppercase" data-id="element-164">
              Esta oferta termina en:
            </span>
            <CountdownTimer size="sm" theme="light" data-id="element-165" />
          </div>
        </div>

        {/* Pricing Cards */}
        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 items-stretch max-w-5xl mx-auto mb-16" data-id="element-166">
          {/* STANDARD PACK */}
          <div className={`bg-white rounded-3xl p-6 md:p-8 shadow-sm border-2 transition-all duration-300 flex flex-col ${selectedPlan === 'standard' ? 'border-green-500 shadow-lg' : 'border-gray-200'}`} onClick={() => setSelectedPlan('standard')} data-id="element-167">
            <div className="text-center mb-6" data-id="element-168">
              <span className="inline-block bg-blue-100 text-blue-700 text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wider mb-4" data-id="element-169">
                Pack Esencial
              </span>
              <h3 className="text-2xl font-extrabold text-gray-900 mb-1" data-id="element-170">
                Mega-Pack Gimnasia Artística
              </h3>
              <p className="text-sm text-gray-500" data-id="element-171">
                1 Ebook + 5 Bonos Gratuitos
              </p>
            </div>

            <div className="text-center mb-6 pb-6 border-b border-gray-100" data-id="element-172">
              <span className="text-lg text-gray-400 line-through font-bold" data-id="element-173">
                {CONSTANTS.PRICES.ORIGINAL}
              </span>
              <div className="text-5xl font-black text-gray-900 tracking-tighter my-1" data-id="element-174">
                {CONSTANTS.PRICES.SALE}
              </div>
              <p className="text-sm text-gray-500" data-id="element-175">ARS - Pago Único</p>
            </div>

            <ul className="space-y-3 mb-8 flex-1" data-id="element-176">
              {standardItems.map((item, idx) => <li key={idx} className="flex items-start space-x-3" data-id="element-177">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-178" />
                  <span className="text-gray-700 text-sm font-medium" data-id="element-179">
                    {item.label}
                  </span>
                  {item.free && <span className="ml-auto text-[10px] font-bold text-red-500 bg-red-50 px-2 py-0.5 rounded flex-shrink-0" data-id="element-180">
                      GRATIS
                    </span>}
                </li>)}

              {/* Greyed out premium items */}
              {premiumExtras.map((item, idx) => <li key={`locked-${idx}`} className="flex items-start space-x-3 opacity-30" data-id="element-181">
                  <Check className="w-5 h-5 text-gray-300 flex-shrink-0 mt-0.5" data-id="element-182" />
                  <span className="text-gray-400 text-sm line-through" data-id="element-183">
                    {item.label}
                  </span>
                </li>)}
            </ul>

            <button onClick={handleBuyStandard} className="w-full bg-gray-800 hover:bg-gray-900 text-white font-bold text-lg py-4 px-6 rounded-xl shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200 flex items-center justify-center" data-id="element-184">
              COMPRAR PACK ESENCIAL
              <ArrowRight className="ml-2 w-5 h-5" data-id="element-185" />
            </button>
          </div>

          {/* PREMIUM PACK */}
          <div className={`bg-white rounded-3xl p-6 md:p-8 shadow-xl border-2 transition-all duration-300 flex flex-col relative overflow-hidden ${selectedPlan === 'premium' ? 'border-yellow-500 shadow-2xl scale-[1.02]' : 'border-yellow-300 shadow-lg'}`} onClick={() => setSelectedPlan('premium')} data-id="element-186">
            {/* Popular badge */}
            <div className="absolute top-0 right-0 bg-yellow-500 text-white px-6 py-1.5 rounded-bl-2xl font-bold text-sm tracking-wider uppercase flex items-center space-x-1" data-id="element-187">
              <Crown className="w-4 h-4" data-id="element-188" />
              <span data-id="element-189">Más Elegido</span>
            </div>

            {/* Subtle gold shimmer bg */}
            <div className="absolute inset-0 bg-gradient-to-br from-yellow-50/50 via-transparent to-orange-50/30 pointer-events-none" data-id="element-190"></div>

            <div className="relative text-center mb-6" data-id="element-191">
              <span className="inline-flex items-center space-x-1 bg-yellow-100 text-yellow-800 text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wider mb-4" data-id="element-192">
                <Sparkles className="w-3.5 h-3.5" data-id="element-193" />
                <span data-id="element-194">Pack Premium</span>
              </span>
              <h3 className="text-2xl font-extrabold text-gray-900 mb-1" data-id="element-195">
                Mega-Pack Premium Completo
              </h3>
              <p className="text-sm text-gray-500" data-id="element-196">
                Todo lo esencial + 3 Ebooks exclusivos
              </p>
            </div>

            <div className="relative text-center mb-6 pb-6 border-b border-yellow-100" data-id="element-197">
              <div className="text-5xl md:text-6xl font-black text-gray-900 tracking-tighter my-1" data-id="element-198">
                {CONSTANTS.PRICES.PREMIUM_SALE}
              </div>
              <p className="text-sm text-gray-500" data-id="element-199">ARS - Pago Único</p>
              <span className="inline-block mt-2 bg-green-100 text-green-800 text-xs font-bold px-3 py-1 rounded-full" data-id="element-200">
                Solo $5.000 más por 3 ebooks extra
              </span>
            </div>

            <ul className="space-y-3 mb-4 flex-1 relative" data-id="element-201">
              {/* Standard items included */}
              {standardItems.map((item, idx) => <li key={idx} className="flex items-start space-x-3" data-id="element-202">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-203" />
                  <span className="text-gray-700 text-sm font-medium" data-id="element-204">
                    {item.label}
                  </span>
                  {item.free && <span className="ml-auto text-[10px] font-bold text-red-500 bg-red-50 px-2 py-0.5 rounded flex-shrink-0" data-id="element-205">
                      GRATIS
                    </span>}
                </li>)}

              {/* Divider */}
              <li className="py-2" data-id="element-206">
                <div className="flex items-center space-x-2" data-id="element-207">
                  <div className="flex-1 h-px bg-yellow-200" data-id="element-208"></div>
                  <span className="text-xs font-bold text-yellow-700 uppercase tracking-wider flex items-center space-x-1" data-id="element-209">
                    <Crown className="w-3 h-3" data-id="element-210" />
                    <span data-id="element-211">Exclusivo Premium</span>
                  </span>
                  <div className="flex-1 h-px bg-yellow-200" data-id="element-212"></div>
                </div>
              </li>

              {/* Premium extras */}
              {premiumExtras.map((item, idx) => <li key={`premium-${idx}`} className="flex items-start space-x-3 bg-yellow-50 -mx-2 px-2 py-2 rounded-lg" data-id="element-213">
                  <BookOpen className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" data-id="element-214" />
                  <div data-id="element-215">
                    <span className="text-gray-900 text-sm font-bold block" data-id="element-216">
                      {item.label}
                    </span>
                    <span className="text-gray-500 text-xs" data-id="element-217">{item.desc}</span>
                  </div>
                  <span className="ml-auto text-[10px] font-bold text-yellow-700 bg-yellow-100 px-2 py-0.5 rounded flex-shrink-0 border border-yellow-200" data-id="element-218">
                    NUEVO
                  </span>
                </li>)}
            </ul>

            <button onClick={handleBuyPremium} className="relative w-full bg-yellow-500 hover:bg-yellow-600 text-white font-black text-xl py-5 px-6 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 flex flex-col items-center justify-center" data-id="element-219">
              <span className="flex items-center" data-id="element-220">
                COMPRAR PACK PREMIUM <ArrowRight className="ml-2 w-6 h-6" data-id="element-221" />
              </span>
              <span className="text-sm font-medium text-yellow-100 mt-1" data-id="element-222">
                Acceso inmediato a todo el material
              </span>
            </button>
          </div>
        </div>

        {/* Trust elements */}
        <div className="max-w-3xl mx-auto" data-id="element-223">
          <PaymentBadges data-id="element-224" />

          <div className="mt-6 bg-green-50 rounded-xl p-4 border border-green-100 flex flex-wrap justify-center gap-4 text-sm font-bold text-green-800" data-id="element-225">
            <div className="flex items-center" data-id="element-226">
              <ShieldCheck className="w-4 h-4 mr-1" data-id="element-227" /> Transacción Segura 100%
            </div>
            <div className="flex items-center" data-id="element-228">
              <Star className="w-4 h-4 mr-1" data-id="element-229" /> Garantía 45 Días
            </div>
            <div className="flex items-center" data-id="element-230">
              <Check className="w-4 h-4 mr-1" data-id="element-231" /> Pago Único
            </div>
          </div>
        </div>

        {/* What happens next */}
        <div className="mt-16 max-w-4xl mx-auto" data-id="element-232">
          <h3 className="text-center text-2xl font-bold text-gray-900 mb-8" data-id="element-233">
            ¿Qué pasa después de comprar?
          </h3>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-234">
            <div className="bg-white p-6 rounded-2xl border border-gray-200 text-center" data-id="element-235">
              <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-236">
                <span className="font-black text-xl" data-id="element-237">1</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-238">Pago Seguro</h4>
              <p className="text-sm text-gray-600" data-id="element-239">
                Completás tu pago de forma 100% segura a través de nuestra
                plataforma.
              </p>
            </div>
            <div className="bg-white p-6 rounded-2xl border border-gray-200 text-center" data-id="element-240">
              <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-241">
                <Mail className="w-6 h-6" data-id="element-242" />
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-243">Email Inmediato</h4>
              <p className="text-sm text-gray-600" data-id="element-244">
                Recibís un correo electrónico al instante con tus datos de
                acceso.
              </p>
            </div>
            <div className="bg-white p-6 rounded-2xl border border-gray-200 text-center" data-id="element-245">
              <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-246">
                <Download className="w-6 h-6" data-id="element-247" />
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-248">Descarga Total</h4>
              <p className="text-sm text-gray-600" data-id="element-249">
                Descargás todo el material a tu computadora o celular para
                siempre.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};